"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

function getImageAssetid(template) {
  return template.shots && template.shots.length > 0 ? template.shots[0].assetId : void 0;
}

function handleSelectTemplate(_ref) {
  var hasUpdatePermission = _ref.hasUpdatePermission,
      selectTemplate = _ref.selectTemplate,
      templateIndex = _ref.templateIndex;
  return hasUpdatePermission ? selectTemplate(templateIndex) : null;
}

function TemplateTab(_ref2) {
  var templates = _ref2.templates,
      selectTemplate = _ref2.selectTemplate,
      selectedTemplateIndex = _ref2.selectedTemplateIndex,
      hasUpdatePermission = _ref2.hasUpdatePermission;
  return _react.default.createElement("div", {
    className: "storyboard-tab"
  }, _react.default.createElement("h3", null, "Templates"), _react.default.createElement("p", null, "Use our professionally curated templates and simply make it your own."), _react.default.createElement("div", {
    className: "storyboard-tab__list"
  }, templates.map(function (template, index) {
    var imageAssetId = getImageAssetid(template);
    return _react.default.createElement("div", {
      tabIndex: 0,
      role: "button",
      onKeyDown: handleSelectTemplate({
        hasUpdatePermission: hasUpdatePermission,
        selectTemplate: selectTemplate,
        templateIndex: index
      }),
      onClick: handleSelectTemplate({
        hasUpdatePermission: hasUpdatePermission,
        selectTemplate: selectTemplate,
        templateIndex: index
      }),
      key: template.storyboardId,
      "data-cy": template.storyboardId,
      className: (0, _classnames.default)('template', {
        'template--selectable': hasUpdatePermission
      })
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)('template__image-wrapper', {
        'template__image-wrapper__selected': index === selectedTemplateIndex
      })
    }, _react.default.createElement(_commonReact.AssetSelector, {
      assetId: imageAssetId
    }, function (asset) {
      var _ref3 = asset && asset.assetFiles ? asset.assetFiles : {},
          ORIGINAL = _ref3.ORIGINAL;

      return _react.default.createElement(_uiKit.Image, {
        defaultImageIcon: asset === null ? 'brokenlink' : 'storyboard',
        backgroundSize: "cover",
        imageUrl: ORIGINAL ? ORIGINAL.sourceUrl : '',
        width: "100%",
        height: "115px"
      });
    }), _react.default.createElement("p", {
      className: "storyboard-tab__name"
    }, template.name)));
  })));
}

var _default = TemplateTab;
exports.default = _default;